<template>
   <v-container fluid>
      <v-card flat outlined>
         <v-row no-gutters class="px-3">
            <v-col cols="6" md="3" class="px-2">
               <v-checkbox
                  :disabled="participants.length === 0"
                  label="All Participants"
                  v-model="allparticipant"
                  hide-details
                  @change="updateMaillist"
               ></v-checkbox>
            </v-col>
            <v-col cols="6" md="3" class="px-2">
               <v-checkbox
                  :disabled="selectedstudent.length === 0"
                  label="Only Parents/Guardians"
                  v-model="onlyparent"
                  hide-details
               ></v-checkbox>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="4" class="px-2" align-self="end">
               <v-btn small color="primary" @click="showSubstitutionHelp">Text Substitution</v-btn>
            </v-col>
         </v-row>
         <v-row no-gutters class="py-2 px-2">
            <v-col cols="18" md="10" class="px-2">
               <v-select
                  :disabled="!participants"
                  class="px-2 py-2"
                  hide-details
                  v-model="selectedstudent"
                  :items="participants"
                  label="Participant"
                  item-text="fullname"
                  item-value="school_id"
                  multiple
                  clearable
                  @click:clear="clearParticipant"
               >
                  <template v-slot:selection="{item, index}">
                     <v-chip
                        v-if="index <= 2"
                        close
                        color="primary"
                        text-color="white"
                        label
                        @click:close="removeParticipant(index)"
                     >
                        <span>{{ item.fullname }}</span>
                     </v-chip>
                     <span v-if="index === 3" class="grey--text text-caption">
                        (+{{ selectedstudent.length - 3 }} others)
                     </span>
                  </template>
               </v-select>
            </v-col>
            <v-col cols="2" md="2" align-self="center" class="pr-2">
               <div class="text-right">
                  <v-btn
                     outlined
                     color="primary"
                     :disabled="disableEmailBtn"
                     @click="sendGroupEmail"
                     >Send</v-btn
                  >
               </div>
            </v-col>
         </v-row>
         <v-row no-gutters>
            <v-col cols="12" md="12">
               <v-card outlined class="px-2 mx-5">
                  <v-text-field
                     ref="subject"
                     v-model="msgSubject"
                     label="Subject"
                     @focus="subjectSetFocus"
                     clearable
                  ></v-text-field>
               </v-card>
               <v-row no-gutters>
                  <v-col cols="12" md="12">
                     <v-card dense outlined flat tile class="mt-2 mx-5">
                        <v-row no-gutters>
                           <v-col cols="12" md="12">
                              <v-card v-if="editor">
                                 <!-- Toggle bold -->
                                 <button
                                    @click="toggleBold"
                                    :class="[
                                       {
                                          'is-active': editor.isActive('bold'),
                                       },
                                       'pa-0',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-bold</v-icon>
                                 </button>
                                 <!-- Toggle italic -->
                                 <button
                                    @click="toggleItalic"
                                    :class="[
                                       {
                                          'is-active': editor.isActive('italic'),
                                       },
                                       'pa-0',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-italic</v-icon>
                                 </button>
                                 <!-- Set paragraph -->
                                 <button
                                    @click="setParagraph"
                                    :class="[
                                       {
                                          'is-active': editor.isActive('paragraph'),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-paragraph</v-icon>
                                 </button>
                                 <!-- Toggle heading 1 -->
                                 <button
                                    @click="toggleHeading(1)"
                                    :class="[
                                       {
                                          'is-active': editor.isActive('heading', {
                                             level: 1,
                                          }),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-header-1</v-icon>
                                 </button>
                                 <!-- Toggle heading 2 -->
                                 <button
                                    @click="toggleHeading(2)"
                                    :class="[
                                       {
                                          'is-active': editor.isActive('heading', {
                                             level: 2,
                                          }),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-header-2</v-icon>
                                 </button>
                                 <!-- Toggle heading 3 -->
                                 <button
                                    @click="toggleHeading(3)"
                                    :class="[
                                       {
                                          'is-active': editor.isActive('heading', {
                                             level: 3,
                                          }),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-header-3</v-icon>
                                 </button>
                                 <!-- Toggle heading 4 -->
                                 <button
                                    @click="toggleHeading(4)"
                                    :class="[
                                       {
                                          'is-active': editor.isActive('heading', {
                                             level: 4,
                                          }),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-header-4</v-icon>
                                 </button>
                                 <!-- Bullet list -->
                                 <button
                                    @click="toggleBulletList"
                                    :class="[
                                       {
                                          'is-active': editor.isActive('bulletList'),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-list-bulleted</v-icon>
                                 </button>
                                 <!-- Toggle ordered list -->
                                 <button
                                    @click="toggleOrderedList"
                                    :class="[
                                       {
                                          'is-active': editor.isActive('orderedList'),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-list-numbered</v-icon>
                                 </button>
                                 <!-- Set text alignment left -->
                                 <button
                                    @click="setTextAlignment('left')"
                                    :class="[
                                       {
                                          'is-active': editor.isActive({
                                             textAlign: 'left',
                                          }),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-align-left</v-icon>
                                 </button>
                                 <!-- Set text alignment center -->
                                 <button
                                    @click="setTextAlignment('center')"
                                    :class="[
                                       {
                                          'is-active': editor.isActive({
                                             textAlign: 'center',
                                          }),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-align-center</v-icon>
                                 </button>
                                 <!-- Set text alignment right -->
                                 <button
                                    @click="setTextAlignment('right')"
                                    :class="[
                                       {
                                          'is-active': editor.isActive({
                                             textAlign: 'right',
                                          }),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-align-right</v-icon>
                                 </button>
                                 <!-- Toggle underline -->
                                 <button
                                    @click="toggleUnderLine"
                                    :class="[
                                       {
                                          'is-active': editor.isActive('underline'),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-underline</v-icon>
                                 </button>

                                 <!-- Undo last action -->
                                 <button @click="undoLastAction" class="mr-1 menubtn">
                                    <v-icon small>mdi-undo</v-icon>
                                 </button>
                                 <!-- Redo last action -->
                                 <button @click="redoLastAction" class="mr-1 menubtn">
                                    <v-icon small>mdi-redo</v-icon>
                                 </button>

                                 <!-- Text color selection -->
                                 <input
                                    class="inputcolor"
                                    type="color"
                                    @input="
                                       editor
                                          .chain()
                                          .focus()
                                          .setColor($event.target.value)
                                          .run()
                                    "
                                    :value="editor.getAttributes('textStyle').color"
                                 />
                              </v-card>
                           </v-col>
                        </v-row>
                     </v-card>
                     <v-sheet outlined color="indigo" class="mx-5">
                        <v-card height="40vh" class="px-2 py-2 overflow-y-auto" elevation="0" tile>
                           <editor-content :editor="editor" />
                        </v-card>
                     </v-sheet>
                  </v-col>
               </v-row>
            </v-col>
         </v-row>
      </v-card>

      <v-dialog v-model="helpmodal" max-width="500px">
         <v-card>
            <v-toolbar dense class="primary white--text">
               <v-toolbar-title>Substitution Text</v-toolbar-title>
               <v-spacer></v-spacer>
               <v-btn @click="OKBtnClick">OK</v-btn>
            </v-toolbar>
            <v-card outlined>
               <p class="body-2 px-2 py-2 pt-2">
                  The following codes can be used to substitute certain variables. Please enter the
                  following substitution string (including braces). Please also note that the
                  substitution text is one word.
               </p>

               <v-row no-gutters class="px-2">
                  <v-simple-table dense style="width:100%" class="py-2">
                     <thead>
                        <tr bgcolor="lightgrey">
                           <th style="width:40%">Description</th>
                           <th style="width:60%">Substitution Text</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr>
                           <td>Student's Name</td>
                           <td>{student_fullname}</td>
                        </tr>
                        <tr>
                           <td>Parent's Name</td>
                           <td>{parent_sal_fullname}</td>
                        </tr>
                        <tr>
                           <td>Activity Name</td>
                           <td>{activity_name}</td>
                        </tr>
                        <tr>
                           <td>Term Year</td>
                           <td>{cca_termyear}</td>
                        </tr>
                     </tbody>
                  </v-simple-table>
               </v-row>
            </v-card>
         </v-card>
      </v-dialog>
      <confirm-dialog ref="confirm"></confirm-dialog>

      <show-toast ref="toast"></show-toast>
   </v-container>
</template>

<script>
   import {Editor, EditorContent} from "@tiptap/vue-2";
   import StarterKit from "@tiptap/starter-kit";
   import TextStyle from "@tiptap/extension-text-style";
   import {Color} from "@tiptap/extension-color";
   import TextAlign from "@tiptap/extension-text-align";
   // import Table from "@tiptap/extension-table";
   // import TableRow from "@tiptap/extension-table-row";
   // import TableCell from "@tiptap/extension-table-cell";
   // import TableHeader from "@tiptap/extension-table-header";
   import UnderLine from "@tiptap/extension-underline";
   import ShowToast from "@/components/showToast.vue";
   import ConfirmDlg from "@/components/ConfirmDlg.vue";

   export default {
      props: ["cca_id", "participants"],

      inject: ["ShowMessage"],

      components: {
         EditorContent,
         ShowToast,
      },

      data() {
         return {
            ccaid: this.cca_id,
            allparticipant: false,
            onlyparent: false,
            selectedstudent: [],
            msgSubject: "",
            msgHTMLBody: "",
            editor: null,
            helpmodal: false,
         };
      },

      computed: {
         disableEmailBtn() {
            if (
               this.selectedstudent.length === 0 ||
               !this.msgSubject ||
               this.msgHTMLBody === "<p></p>" ||
               this.msgHTMLBody === ""
            ) {
               return true;
            } else {
               return false;
            }
         },
      },

      methods: {
         showSubstitutionHelp() {
            this.helpmodal = true;
         },

         OKBtnClick() {
            this.helpmodal = false;
         },

         removeParticipant(index) {
            this.selectedstudent.splice(index, 1);
            this.allparticipant = this.selectedstudent.length === this.allparticipant.length;
         },

         clearParticipant() {
            if (this.allparticipant) {
               this.allparticipant = false;
            }
         },

         updateMaillist() {
            if (this.allparticipant) {
               this.selectedstudent = [...this.participants];
            } else {
               this.selectedstudent.splice(0);
            }
         },

         checkEmailSettings() {
            let result = true;
            if (!this.msgSubject || !this.msgHTMLBody || this.msgHTMLBody === "<p></p>") {
               result = false;
               this.ShowMessage({
                  title: "Error",
                  message: "Email subject or body is empty",
                  color: "red",
               });
            }

            return result;
         },

         sendGroupEmail() {
            if (!this.selectedstudent) {
               this.ShowMessage({
                  title: "Error",
                  message: "Please select students to send message.",
                  color: "red",
               });
            } else if (!this.msgSubject) {
               this.ShowMessage({
                  title: "Error",
                  message: "Please enter a message subject.",
                  color: "red",
               });
            } else if (!this.msgHTMLBody) {
               this.ShowMessage({title: "Error", message: "Please enter a message.", color: "red"});
            } else {
               this.sendGroupEmail();
            }
         },

         async doSendGroupEmail() {
            await this.$http({
               url: "/cca/sendgroupemail.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.cca_id,
                  student_list: this.selectedstudent,
                  parent_only: this.onlyparent,
                  msg_subject: this.msgSubject,
                  msg_body: this.msgHTMLBody,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                     this.msgSubject = "";
                     this.editor.commands.setContent(`<p></p>`);
                     this.msgHTMLBody = "";
                     this.allparticipant = false;
                     this.onlyparent = false;
                     this.selectedstudent = [];
                  }
               }
            });
         },

         initMessageEditor() {
            this.editor = new Editor({
               onUpdate: () => {
                  this.msgHTMLBody = this.editor.getHTML();
                  this.subjectHasFocus = false;
               },
               extensions: [
                  StarterKit,
                  TextStyle,
                  Color,
                  TextAlign.configure({
                     types: ["heading", "paragraph"],
                  }),
                  // Table.configure({
                  //    resizable: true,
                  // }),
                  // TableRow,
                  // TableCell,
                  // TableHeader,
                  UnderLine,
               ],
               content: "",
            });
         },

         subjectSetFocus() {
            this.subjectHasFocus = true;
         },

         toggleBold() {
            this.editor
               .chain()
               .focus()
               .toggleBold()
               .run();
         },

         toggleItalic() {
            this.editor
               .chain()
               .focus()
               .toggleItalic()
               .run();
         },

         setParagraph() {
            this.editor
               .chain()
               .focus()
               .setParagraph()
               .run();
         },

         toggleHeading(headinglevel) {
            this.editor
               .chain()
               .focus()
               .toggleHeading({level: headinglevel})
               .run();
         },

         toggleBulletList() {
            this.editor
               .chain()
               .focus()
               .toggleBulletList()
               .run();
         },
         toggleOrderedList() {
            this.editor
               .chain()
               .focus()
               .toggleOrderedList()
               .run();
         },

         setTextAlignment(position) {
            console.log("setting alignment", position);
            this.editor
               .chain()
               .focus()
               .setTextAlign(position)
               .run();
         },

         toggleUnderLine() {
            this.editor
               .chain()
               .focus()
               .toggleUnderline()
               .run();
         },
         undoLastAction() {
            this.editor
               .chain()
               .focus()
               .undo()
               .run();
         },

         redoLastAction() {
            this.editor
               .chain()
               .focus()
               .redo()
               .run();
         },
      },

      mounted() {
         if (this.participants && this.allparticipant) {
            this.selectedstudent = [...this.participants];
         }
         this.initMessageEditor();
      },
   };
</script>
